import { useState } from "react";
import { glossaryTerms, faqs, testimonials } from "@/mocks/chigua";

export default function InfoSections() {
  const [term, setTerm] = useState(glossaryTerms[0].term);
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  const activeTerm = glossaryTerms.find((g) => g.term === term) ?? glossaryTerms[0];

  return (
    <>
      <section id="glossary" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid items-center gap-10 lg:grid-cols-2">
            <div>
              <p className="text-sm font-semibold tracking-widest text-primary-500 uppercase">吃瓜词典</p>
              <h2 className="mt-2 font-fun text-3xl text-foreground-950 md:text-4xl">黑话也能一眼懂</h2>
              <p className="mt-2 max-w-lg text-foreground-600">
                刚入圈的围观新人不慌，常用吃瓜黑话随手查。点任意一个词条，立刻看懂评论区在说啥。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {glossaryTerms.map((g) => (
                  <button
                    key={g.term}
                    type="button"
                    onClick={() => setTerm(g.term)}
                    className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm font-semibold transition-colors ${
                      term === g.term
                        ? "border-primary-500 bg-primary-500 text-background-50"
                        : "border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                    }`}
                  >
                    {g.term}
                  </button>
                ))}
              </div>
            </div>

            <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 to-primary-500 p-8 text-background-50">
              <i className="ri-chat-quote-line absolute -right-4 -top-4 text-[120px] text-background-50/10" aria-hidden="true"></i>
              <p className="text-xs font-semibold uppercase tracking-widest text-accent-300">当前词条</p>
              <h3 className="mt-3 font-fun text-3xl">{activeTerm.term}</h3>
              <p className="mt-4 max-w-md text-lg leading-8 text-background-50/90">{activeTerm.def}</p>
              <p className="mt-6 text-sm text-background-50/60">
                还遇到看不懂的词？欢迎留言，我们会持续补充进词典。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="max-w-2xl">
            <p className="text-sm font-semibold tracking-widest text-primary-500 uppercase">常见问题</p>
            <h2 className="mt-2 font-fun text-3xl text-foreground-950 md:text-4xl">围观之前，先看这里</h2>
            <p className="mt-2 text-foreground-600">关于看吃瓜的信息来源、更新频率与使用方式，常见疑问一次性解答。</p>
          </div>

          <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_400px]">
            <div className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {faqs.map((f, i) => {
                const open = openFaq === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenFaq(open ? null : i)}
                      className="flex w-full items-center gap-4 px-6 py-5 text-left"
                      aria-expanded={open}
                    >
                      <span className="flex-1 text-base font-semibold text-foreground-900">{f.q}</span>
                      <i
                        className={`text-xl text-primary-500 transition-transform duration-200 ${open ? "ri-subtract-line" : "ri-add-line"}`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    {open && <p className="px-6 pb-6 text-[15px] leading-7 text-foreground-600">{f.a}</p>}
                  </div>
                );
              })}
            </div>

            <aside className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <h3 className="font-fun text-xl text-foreground-900">围观群众这样说</h3>
              <p className="mt-1 text-sm text-foreground-500">来自真实站内用户的使用反馈</p>
              <div className="mt-5 space-y-4">
                {testimonials.map((t) => (
                  <figure key={t.name} className="rounded-xl bg-background-100 p-4">
                    <blockquote className="text-sm leading-6 text-foreground-700">"{t.quote}"</blockquote>
                    <figcaption className="mt-3 flex items-center gap-2 text-sm">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 font-bold text-primary-700">
                        {t.name.slice(0, 1)}
                      </span>
                      <span>
                        <span className="block font-semibold text-foreground-900">{t.name}</span>
                        <span className="block text-xs text-foreground-400">{t.role}</span>
                      </span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </section>
    </>
  );
}